// extracted by mini-css-extract-plugin
export var container = "_8b-0";
export var icon = "_8b-1";
export var text = "_8b-2";